import '@/scss/pages/pricing/pricing.scss';
import {faq} from "@/js/global/components/faq";


window.addEventListener('load', () => {
    faq();
});